import { PropsWithChildren } from 'react'

export const DemoListItem = ({ children }: PropsWithChildren) => {
  return <li className="pt-[10px]">{children}</li>
}
